(() => {
  if (customElements.get('abok-product-offer')) return;

  const ZONED_INSTANT = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?(?:Z|[+-]\d{2}:\d{2})$/i;

  class AbokProductOffer extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;

      this.abortController = new AbortController();
      this.copyButton = this.querySelector('[data-abok-offer-copy]');
      this.codeInput = this.querySelector('[data-abok-offer-code]');
      this.countdown = this.querySelector('[data-abok-offer-countdown]');
      this.time = this.querySelector('[data-abok-offer-time]');
      this.status = this.querySelector('[data-abok-offer-status]');

      this.copyButton?.addEventListener('click', () => this.copyCode(), {
        signal: this.abortController.signal,
      });
      this.initializeCountdown();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
      window.clearInterval(this.timer);
    }

    initializeCountdown() {
      const rawEndAt = String(this.dataset.endAt || '').trim();
      if (!rawEndAt || !this.countdown || !this.time || !ZONED_INSTANT.test(rawEndAt)) return;

      this.endAt = Date.parse(rawEndAt);
      if (!Number.isFinite(this.endAt)) return;

      this.countdown.hidden = false;
      this.updateCountdown();
      if (this.dataset.state !== 'expired') {
        this.timer = window.setInterval(() => this.updateCountdown(), 1000);
      }
    }

    updateCountdown() {
      const remaining = this.endAt - Date.now();
      if (remaining <= 0) {
        window.clearInterval(this.timer);
        this.dataset.state = 'expired';
        this.time.textContent = this.dataset.expiredLabel || 'Offer ended';
        this.time.removeAttribute('datetime');
        if (this.copyButton) this.copyButton.disabled = true;
        return;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      const pad = (value) => String(value).padStart(2, '0');

      this.time.dateTime = new Date(this.endAt).toISOString();
      this.time.textContent = `${days}d ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    }

    async copyCode() {
      if (!this.codeInput?.value) return;

      try {
        await navigator.clipboard.writeText(this.codeInput.value);
        this.status.textContent = this.dataset.copySuccess || 'Code copied.';
      } catch (_error) {
        this.codeInput.focus();
        this.codeInput.select();
        this.status.textContent = this.dataset.copyFallback || 'Select and copy the code.';
      }
    }
  }

  customElements.define('abok-product-offer', AbokProductOffer);
})();
